import { Tile, TileStripe } from "@dash/tile";
import { useTheme } from "@emotion/react";
import { Link } from "react-router-dom-v5-compat";
import tinycolor from "tinycolor2";

import { getMegaraxPath } from "@megaron/megarax-uri";

import type { FC } from "react";
type Props = {
  orderNumber: string;
  sellToName: string | null;
};

export const SupportTicketOrderTile: FC<Props> = ({ orderNumber, sellToName }) => {
  const theme = useTheme();
  const color = theme.colors.primary;

  return (
    <Link
      to={getMegaraxPath.uri("megarax://crm/orders/number/{number}", { number: orderNumber })}
      css={{
        display: "block",
        ":hover": {
          textDecoration: "none",
          h4: {
            textDecoration: "underline",
          },
        },
      }}
    >
      <Tile
        stripe={<TileStripe color={color} />}
        css={{
          borderRadius: theme.smallBorderRadius,
          border: `1px solid ${tinycolor(color).setAlpha(0.1)}`,
          height: "auto",
          "& > div:last-of-type": {
            flex: "0 0 auto",
            justifyContent: "flex-start",
            padding: "0.375rem 0.625rem",
          },
        }}
      >
        <div
          css={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            width: "100%",
          }}
        >
          <span
            css={{
              fontSize: "16px",
              color,
            }}
          >
            {orderNumber}
          </span>
          {sellToName ? <span css={{ fontSize: "14px", color: theme.colors.secondaryText }}>{sellToName}</span> : null}
        </div>
      </Tile>
    </Link>
  );
};
